import { create } from "zustand";

import AdminApiCaller from "../config/api/adminapicaller";

const initialState = {
  pendingItems: {},
  userStats: {},
  topCountries: [],
  isPendingLoading: false,
  isUserStatsLoading: false,
  isTopCountriesLoading: false,
  error: null,
};

export const useDashboardStore = create((set) => {
  const setDashboard = (partial) =>
    set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    getPendingItems: async (cb) => {
      try {
        setDashboard({ isPendingLoading: true, error: null });
        const res = await AdminApiCaller.Get("/get-pending-items");
        if (res?.status === 200) {
          setDashboard({
            pendingItems: res.data.pendingCounts,
            isPendingLoading: false,
          });
        } else {
          setDashboard({ isPendingLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setDashboard({ isPendingLoading: false, error: err });
      }
    },
    getUserStats: async (cb) => {
      try {
        setDashboard({ isUserStatsLoading: true, error: null });
        const res = await AdminApiCaller.Get("/get-user-stats");
        if (res?.status === 200) {
          setDashboard({
            userStats: res.data.userStats,
            isUserStatsLoading: false,
          });
        } else {
          setDashboard({ isUserStatsLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setDashboard({ isUserStatsLoading: false, error: err });
      }
    },
    getTopCountries: async (payload, cb) => {
      try {
        setDashboard({ isTopCountriesLoading: true, error: null });
        const fromDate = payload?.fromDate ?? "";
        const toDate = payload?.toDate ?? "";
        const res = await AdminApiCaller.Get(
          `/get-top-countries?fromDate=${fromDate}&toDate=${toDate}`
        );
        if (res?.status === 200) {
          setDashboard({
            topCountries: res.data.topCountries,
            isTopCountriesLoading: false,
          });
        } else {
          setDashboard({ isTopCountriesLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setDashboard({ isTopCountriesLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
